module.exports = __webpack_public_path__ + "img/banner.5b6688bf.png";